import axios from "axios";
import {
  logoutUser,
  setIsUserLoggedInWithOkta,
} from "../features/auth/authLoginSlice";
import { getFileDetails, getUserDetails } from "./utils";
import {
  setMultipleFirmsUser,
} from "../features/lawFirm/lawFirmSlice";

 let baseURL = window?.__ENV?.API_BASE_URL || '';
// This localAPI allows us to call our API's in short format.

export const localAPI = axios.create({
  baseURL: `${baseURL}/data`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const http = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// This allows us to intercept each api call and format each api call.
// This also allows us to perform some operation on a certain error code.
// It also allows us to easily add bearer token in our api calls.

export const interceptor = (store) => {
  http.interceptors.request.use((config) => {
    config.headers = authHeader(store.dispatch);
    if (!JSON.stringify(config.data).includes("RequestObject"))
      config.data = { RequestObject: config.data };
    return config;
  });
  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const code =
        error.response && error.response.data
          ? error.response.data.status
          : error.response.status;
      if (code === 401) {
        store.dispatch(logoutUser());
      }
      if (error?.response?.data === "Unauthorized URL Access.") {
        alert("Unauthorized access to the file.");
      }
      return Promise.reject(error);
    }
  );
};
console.log("HTTP", http);
export default http;

export function authHeader(dispatch) {
  const user = getUserDetails();
  const file = getFileDetails();
  if (user?.userLawFirms && user?.userLawFirms?.length > 0) {
    dispatch(setMultipleFirmsUser(true));
  }
  if (user?.idToken) {
    dispatch(setIsUserLoggedInWithOkta());
  }
  if (user && user.token) {
    return {
      authorization: `Bearer ${user.token}`,
      CustomHeaderUserID: user.userId,
      CustomHeaderFileID: file && file?.fileID ? file?.fileID : 0,
    };
  } else {
    return {};
  }
}
